function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "check_svg__a",
  d: "M0 0h25v25H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "check_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#check_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#2176FF",
  d: "M0 12.53C.017 19.434 5.627 25.017 12.53 25c6.904-.017 12.487-5.627 12.47-12.53C24.983 5.566 19.373-.017 12.47 0 5.566.017-.017 5.627 0 12.53",
  mask: "url(#check_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.15,
  d: "M19.154 7.546c-2.943 4.231-6.974 7.74-9.562 12.208l5.08 5.054c5.88-1.03 10.343-6.165 10.328-12.338a12.606 12.606 0 00-.26-2.521L20.731 5.96l-1.578 1.585z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.258 11.601l5.513 8.307L20.724 5.961 9.439 14.949z"
}));

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0idXRpeHpldW1rYSIgZD0iTTAgMEwyNSAwIDI1IDI1IDAgMjV6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MDQgLTE1NzgpIHRyYW5zbGF0ZSg5MDQgMTU3OCkiPgogICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSI2YjNvc3E5cWNiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdXRpeHpldW1rYSIvPgogICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMjE3NkZGIiBkPSJNMCAxMi41M0MuMDE3IDE5LjQzNCA1LjYyNyAyNS4wMTcgMTIuNTMgMjVjNi45MDQtLjAxNyAxMi40ODctNS42MjcgMTIuNDctMTIuNTNDMjQuOTgzIDUuNTY2IDE5LjM3My0uMDE3IDEyLjQ3IDAgNS41NjYuMDE3LS4wMTcgNS42MjcgMCAxMi41MyIgbWFzaz0idXJsKCM2YjNvc3E5cWNiKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuMTUiIGQ9Ik0xOS4xNTQgNy41NDZjLTIuOTQzIDQuMjMxLTYuOTc0IDcuNzQtOS41NjIgMTIuMjA4bDUuMDggNS4wNTRjNS44OC0xLjAzIDEwLjM0My02LjE2NSAxMC4zMjgtMTIuMzM4LS4wMDItLjg2NC0uMDkyLTEuNzA3LS4yNi0yLjUyMUwyMC43MzEgNS45NmwtMS41NzggMS41ODV6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTA0IC0xNTc4KSB0cmFuc2xhdGUoOTA0IDE1NzgpIi8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNC4yNTggMTEuNjAxTDkuNzcxIDE5LjkwOCAyMC43MjQgNS45NjEgOS40MzkgMTQuOTQ5eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkwNCAtMTU3OCkgdHJhbnNsYXRlKDkwNCAxNTc4KSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgCheck as ReactComponent };